import { deleteRequirement } from './deleteRequirementThunk';
export default deleteRequirement;
